import { motion } from "framer-motion";
import { BATTERY } from "../../lib/data";
import { Reveal, Overline, Icon } from "../ui-kit";

export default function Battery() {
  return (
    <section className="relative py-24 md:py-32 bg-[#050505] overflow-hidden" data-testid="battery-section">
      {/* Glow */}
      <div className="absolute left-1/2 top-0 -translate-x-1/2 h-[500px] w-[900px] rounded-full blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(255,90,0,0.12) 0%, transparent 70%)" }} />

      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <Overline index="03">20V Battery Platform</Overline>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white leading-[0.95]">
              One Battery.<br />
              <span className="text-orange-500">Endless</span> Possibilities.
            </h2>
            <p className="mt-6 text-lg text-zinc-400 leading-relaxed max-w-lg">
              Every Sobtrex cordless power tool is powered by a common 20V lithium-ion battery platform,
              letting professionals use one battery across multiple tools — reducing cost and increasing convenience.
            </p>

            {/* Big battery render placeholder */}
            <Reveal delay={0.1} className="mt-10">
              <div className="brushed relative h-40 w-full max-w-md border border-zinc-800 clip-notch flex items-center px-8 gap-6 overflow-hidden">
                <div className="absolute inset-0 noise" />
                <div className="relative flex items-center justify-center h-20 w-20 border border-orange-500/40 bg-black text-orange-500">
                  <Icon name="BatteryCharging" size={38} />
                </div>
                <div className="relative">
                  <p className="font-display text-4xl font-black text-white">20V</p>
                  <p className="text-sm font-bold uppercase tracking-widest text-orange-500">Lithium-Ion</p>
                  <p className="text-xs text-zinc-500 mt-1">Max Performance Platform</p>
                </div>
              </div>
            </Reveal>
          </div>

          {/* Grid of platform accessories */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {BATTERY.map((b, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.92 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                whileHover={{ y: -6 }}
                className={`group bg-[#101012] border border-zinc-800 hover:border-orange-500/50 p-5 transition-colors ${
                  i === BATTERY.length - 1 ? "col-span-2 sm:col-span-1" : ""
                }`}
                data-testid={`battery-item-${i}`}
              >
                <div className="text-orange-500 group-hover:scale-110 transition-transform origin-left">
                  <Icon name={b.icon} size={26} />
                </div>
                <p className="mt-4 font-display text-sm font-bold uppercase text-white leading-tight">{b.name}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
